import { render } from "./PaginaInicio.vue?vue&type=template&id=aa0a04e4&scoped=true"
import script from "./PaginaInicio.vue?vue&type=script&lang=js"
export * from "./PaginaInicio.vue?vue&type=script&lang=js"

import "./PaginaInicio.vue?vue&type=style&index=0&id=aa0a04e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0a04e4"]])

export default __exports__